export default [
  {
    title: 'breadcrumb.match',
    route: 'list-match',
    icon: '',
    resource: 'bet-setting',
    action: 'read'
  }
];